import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={46}
    height={23}
    fill="none"
    {...props}
    style={{transform:(props.isLeft ? 'rotate(180deg)' : '')}}
  >
    <path
      fill="#fff"
      d="M31.762 22.042a1.075 1.075 0 0 1-.671-1.917l11.478-9.104-11.473-9.105a1.07 1.07 0 0 1-.172-1.509 1.07 1.07 0 0 1 1.51-.172l12.536 9.948a1.077 1.077 0 0 1 0 1.686l-12.536 9.948a1.079 1.079 0 0 1-.666.23l-.006-.005ZM16.416 22.042a1.075 1.075 0 0 1-.67-1.917l11.478-9.104L15.75 1.915a1.07 1.07 0 0 1-.172-1.509 1.07 1.07 0 0 1 1.509-.172l12.542 9.948a1.077 1.077 0 0 1 0 1.686l-12.542 9.948a1.079 1.079 0 0 1-.666.23l-.006-.005ZM1.077 22.043a1.075 1.075 0 0 1-.672-1.917l11.479-9.105L.41 1.918A1.076 1.076 0 0 1 .233.408a1.076 1.076 0 0 1 1.51-.177l12.542 9.947a1.077 1.077 0 0 1 0 1.687L1.743 21.812a1.08 1.08 0 0 1-.666.231Z"
    />
  </svg>
)
export default SvgComponent
